var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 3H11.6C12.9255 3 14 4.11929 14 5.5V10.5C14 11.8807 12.9255 13 11.6 13H4.4C3.07452 13 2 11.8807 2 10.5V5.5C2 4.11929 3.07452 3 4.4 3ZM8.82763 6.61598L8.21508 5.32743C8.12693 5.14201 7.87307 5.14201 7.78492 5.32743L7.17237 6.61598C7.13742 6.68951 7.07005 6.74049 6.99212 6.75239L5.62636 6.96106C5.42984 6.99108 5.35139 7.24258 5.49344 7.3872L6.48062 8.39223C6.53695 8.44958 6.56268 8.53207 6.54947 8.61296L6.31794 10.0305C6.28462 10.2344 6.49 10.3899 6.66594 10.2938L7.8886 9.62643C7.95837 9.58835 8.04163 9.58835 8.1114 9.62643L9.33406 10.2938C9.51 10.3899 9.71538 10.2344 9.68206 10.0305L9.45053 8.61296C9.43732 8.53207 9.46305 8.44958 9.51938 8.39223L10.5066 7.3872C10.6486 7.24258 10.5702 6.99108 10.3736 6.96106L9.00788 6.75239C8.92995 6.74049 8.86258 6.68951 8.82763 6.61598Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/Membership.6491fd4077bb7351191aa6e348e2d52a.svg";
export { ForwardRef as ReactComponent };